import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";
import { Banner } from "../../shared/models/banner";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule, MatExpansionPanel } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { PasswordResetComponent } from "../passwordreset/passwordreset.component";
import { PasswordResetConfirmComponent } from "../passwordresetconfirm/passwordresetconfirm.component";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";


@Component({
    selector: "div.dtf-adminpage",
    imports: [SharedTranslateModule,SessionTimeoutComponent, PasswordResetConfirmComponent, MatTableModule, FormsModule, MatRadioModule, ReactiveFormsModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatCheckboxModule],
    templateUrl: './admin.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class AdminComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  passwordResetFlag = false;

  agentview: string;
  agentId: string;
  isAdmin: string;
  adminUserType: string;
  token: string;
  brandId: string;
  serviceErrorDesc = '';

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil,
    public auth: AuthorizationService,
  ) {
    // console.log("admin constructor called");
    // const code = this._window.nativeWindow?.mbfs?.code;
    // console.log("code from mbfs: ", code);
    this.router = router;
    
   
}
  ngOnInit() {
    console.log("admin ngOnInit called");
    console.log(sessionStorage.getItem('username'));
    console.log("username from session: ", sessionStorage.getItem('username'));

    const code = this._window.nativeWindow?.mbfs?.code;
    console.log("code from mbfs: ", code);
    const authUrl = (this._window.nativeWindow as any)?.mbfs?.authorizationUrl;
      if (!code) {
    sessionStorage.clear();
     window.location.replace(authUrl);
     return;
      }
    
    const username = sessionStorage.getItem('username');
    if (username!== null && username !== undefined && username !== '') {
      console.log('User found in session storage'+sessionStorage.getItem('username'));
      return ;
    }
    sessionStorage.setItem('code', code);
    const language = this._window.nativeWindow?.mbfs.language;
    const sessionState = this._window.nativeWindow?.mbfs?.sessionState;

  
      this.auth.oidcToken({
        code,
        state: sessionState
      }).subscribe({
        next: (response) => {
  
          if (!response?.oidcToken) {
            this.router.navigate(['/home/acm']);
            return;
          }
  
          const { oidcToken, oidcUserBean } = response;
  
          sessionStorage.setItem('oidcToken', atob(oidcToken));
          sessionStorage.setItem('username', oidcUserBean.userId);
          sessionStorage.setItem('userId', oidcUserBean.userId);
          sessionStorage.setItem('email', oidcUserBean.email);
  
          console.log('OIDC authentication successful');
  

          const loginRequest = {
      userId : oidcUserBean.userId,
      password : "",
      country: this.currentCountry,
      language : language,
      recaptcha : false
    };
    this.getAdminLogin(loginRequest);


          // Navigate after successful login if needed
          // this.router.navigate(['/home/admindashboard']);
        },
        error: (error) => {
          console.error('OIDC authentication failed', error);
          this.router.navigate(['/home/acm']);
        }
      });
    

    
  
    
    // const loginRequest = {
    //   userId : sessionStorage.getItem('username'),
    //   password : "",
    //   country: this.currentCountry,
    //   language : language,
    //   recaptcha : false
    // };
    // this.getAdminLogin(loginRequest);

    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    //this.getAlerts();
    const passwordreset = (this._window.nativeWindow as any).mbfs.passwordreset;
    if(passwordreset !=""){
      this.checkPassword();
    }
    this.langInit();
  }

  getAdminLogin(loginRequest) {
    // this.loginLoaded = false; //Spinner enabler
    this.auth.adminLogin(loginRequest).subscribe(res => {
        // this.loginLoaded = true;
        if (res.userValid){
          sessionStorage.setItem("username", res.userId);
          this.auth.getAuthToken().subscribe(authRes=> {
            sessionStorage.setItem("Authorization", authRes.token);
            sessionStorage.setItem("userId", authRes.userId);
          sessionStorage.setItem('adminauth', 'yes');
          sessionStorage.setItem('isAdmin',res.admin);
          sessionStorage.setItem('adminUserType',res.userType);
          sessionStorage.setItem('AdminName',res.userId);
          sessionStorage.setItem('emailAddress',res.emailAddress);

          this.agentview = sessionStorage.getItem('agentview');
          this.agentId = sessionStorage.getItem('agentID');
          this.isAdmin = sessionStorage.getItem('isAdmin');
          this.adminUserType = sessionStorage.getItem('adminUserType');
          this.brandId = sessionStorage.getItem('brandId');
          this.token = sessionStorage.getItem('ciamToken');

          this.auth.isAdminAuthenticated(); // Checks if user is authenticated
          // this.openLoginModal = false;
          this._window.nativeWindow.location.href = this.usUrl + '/home/admindashboard';
        });
         } else if (res.userValid === false) {
          sessionStorage.clear();
          this._window.nativeWindow.location.href = this.usUrl + '/home';

          // this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
          //   this.serviceErrorDesc = data;
          //  });
        } else {
         const msg = res.status.message;
         this.serviceErrorDesc =
           loginRequest.language === 'en-CA' ? msg.shortMessage_EN :
           loginRequest.language === 'fr-CA' ? msg.shortMessage_FR :
           msg.shortMessage;
        }
  });
}


  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  checkPassword(){
    this.passwordResetFlag=true;
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     });
  // }
}
